import { ValidatorFn, FormGroup, ValidationErrors, Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import { Directive } from "@angular/core";
import { DateTime } from "../app/models/DateTime";

/** The check-out can't take place before the check-in */
export const isDateTimeAfterValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
   
    const startDateTime = new DateTime();
    const endDateTime = new DateTime();

    startDateTime.date = control.get('startDate') && control.get('startDate').value;
    startDateTime.time = control.get('startTime') && control.get('startTime').value;
    endDateTime.date = control.get('endDate') && control.get('endDate').value;
    endDateTime.time = control.get('endTime') && control.get('endTime').value;
    
    return (startDateTime && endDateTime && startDateTime.getDate() >= endDateTime.getDate()) ? { 'payIsDateTimeAfter': true } : null;
};

@Directive({
    selector: '[payIsDateTimeAfter]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IsDateTimeAfterValidatorDirective, multi: true }]
})
export class IsDateTimeAfterValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return isDateTimeAfterValidator(control)
  }
}


// WEBPACK FOOTER //
// ./src/directives/is-date-time-after-valitator.directive.ts